import React from "react";
import { NavLink } from "react-router-dom";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";

import {
  StyledCol,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../../styles/styledTable";
import { StyledCashFlowProfitDetailsWrapper } from "../styledCashFlowProfit";
import { StyledBreakWord } from "../../../../styles/styledBreakWord";
import { useTranslation } from "react-i18next";

const CashFlowProfitDetailsList = ({ url, profitDetails }) => {
  const { t } = useTranslation("cashFlow");

  if (!profitDetails) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (profitDetails.length === 0) {
    return <Alert severity="warning">{t("profit.table.emptyData")}</Alert>;
  }

  return (
    <StyledCashFlowProfitDetailsWrapper>
      <StyledTable
        size="14"
        className="service-profit-table"
      >
        <StyledTableHead col="2" className="service-profit-table__head">
          <div>
            {t("profit.table.user")}
          </div>
          <div>
            {t("profit.table.profit")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {profitDetails && profitDetails.map((value, key) => (
            <StyledTableRow
              as={NavLink}
              to={`/clients/${value.id}?currentTab=profits${url}`}
              col="2"
              key={key}
              cursor="pointer"
              className="service-profit-table__row"
            >
              <StyledCol data-title={t("profit.table.user")} inline>
                <StyledBreakWord>
                  {value.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol data-title={t("profit.table.profit")}>
                {value.profit} {value.asset}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledCashFlowProfitDetailsWrapper>
  );
};

export default CashFlowProfitDetailsList;